import PropTypes from 'prop-types';

// @mui material components
import Grid from '@mui/material/Grid';

// Argon Dashboard 2 PRO MUI components
import ArgonBox from 'component/Argon/ArgonBox';

// Argon Dashboard 2 PRO MUI example components
import PageLayout from 'layout/LayoutContainers/PageLayout';

function BasicLayout({ children }) {
  return (
    <PageLayout>
      <ArgonBox display="grid" alignItems="center" width="100%" height="100vh" minHeight="100vh">
        <ArgonBox px={1} pt={4} width="100%" mx="auto">
          <Grid container justifyContent="center">
            <Grid item xs={11} sm={9} md={5}>
              {children}
            </Grid>
          </Grid>
        </ArgonBox>
      </ArgonBox>
    </PageLayout>
  );
}

// Setting default values for the props of BasicLayout

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
